import { render } from "./FragranceProfile.vue?vue&type=template&id=6e4d55aa&scoped=true"
import script from "./FragranceProfile.vue?vue&type=script&lang=js"
export * from "./FragranceProfile.vue?vue&type=script&lang=js"

import "./FragranceProfile.vue?vue&type=style&index=0&id=6e4d55aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4d55aa"]])

export default __exports__